export default __webpack_public_path__ + "static/media/1n2.65dc0953.webp";